import glamorous from 'glamorous';
import themes from '../themes'

export default glamorous.div(
    {
        fontSize: 22,
        width: '200px',
        height: '40px',
        userSelect: 'none',
        cursor: 'pointer',
        padding: '10px',
        transition: '0.25s cubic-bezier(0.17, 0.67, 0.52, 0.97)',
        ':hover': {
            opacity: 0.5,
        },
        ':focus': { outline: 0 }
         },
         props => {
            switch (props.theme) {
            case "dark": {
                if (props.selected === false) {
                    return 
                }
                else {
                    return { 
                        color: themes[0].accent,
                        ":hover": {opacity: 1}
                    }
                }
            }
            case "light": {
                if (props.selected === false) {
                    return 
                }
                else {
                    return { 
                        color: themes[1].accent,
                        ":hover": {opacity: 1} 
                    } 
                }
            }
        }
    }
);


// WEBPACK FOOTER //
// ./src/components/ChapterButton.js